import React, { Suspense, lazy } from 'react'

import LoadingIndicator from 'components/LoadingIndicator'

const Loader = ({ children }: any) => (
  <Suspense fallback={<LoadingIndicator />}>{children}</Suspense>
)

// BerthSizePage は withRouter(connect(...)) でラップされており、react-redux v8 の型では
// 注入される props (openToast/userData/tenants 等) が必須として漏れる。
// 実際は connect / withRouter が全て注入するため、props 不要な component として型付けする。
const BerthSizePage = lazy(
  () => import('./pages/BerthSizePage')
) as unknown as React.LazyExoticComponent<React.ComponentType>

export const BerthSizePageLoader = () => (
  <Loader>
    <BerthSizePage />
  </Loader>
)

const NotificationSoundPage = lazy(() => import('./pages/NotificationSoundPage'))

export const NotificationSoundPageLoader = () => (
  <Loader>
    <NotificationSoundPage />
  </Loader>
)

const TenantSettingUnitTimePage = lazy(() => import('./pages/TenantSettingUnitTimePage'))

export const TenantSettingUnitTimePageLoader = () => (
  <Loader>
    <TenantSettingUnitTimePage />
  </Loader>
)
